import app from 'app';

import addToCart from './product/add-to-cart';
import colorOptions from './product/color-options';
import fabricSection from './product/fabric-section';
import productFeatures from './product/features';
import floatingForm from './product/floating-form';
import fullscreenImages from './product/fullscreen-images';
import images from './product/images';
import lightbox from './product/lightbox';
import lookForm from './product/look-form';
import lookImages from './product/look-images';
import lookItem from './product/look-item';
import main from './product/main';
import media from './product/media';
import modalSlider from './product/modal-slider';
import productNavigation from './product/product-navigation';
import recommendationsSliders from './product/recommendations-sliders';
import sizeGuide from './product/size-guide';
import stickyProductForm from './product/sticky-product-form';
import swap from './product/swap';
import swatches from './product/swatches';
import variantSelector from './product/variant-selector';
import yotpoReviews from './product/yotpo-reviews';
import zoomImage from './product/zoom-image';

app.add({
  main,
  'product-floating-form': floatingForm,
  'product-lightbox': lightbox,
  'product-look-form': lookForm,
  'product-media': media,
  'product-swap': swap,
  'product-variant-selector': variantSelector,
  'product-images': images,
  'fullscreen-images': fullscreenImages,
  'product-add-to-cart': addToCart,
  'product-swatches': swatches,
  'sticky-product-form': stickyProductForm,
  'modal-slider': modalSlider,
  'product-navigation': productNavigation,
  'size-guide': sizeGuide,
  'fabric-section': fabricSection,
  'product-features': productFeatures,
  'yotpo-reviews': yotpoReviews,
  'zoom-image': zoomImage,
  'look-images': lookImages,
  'look-item': lookItem,
  'product-recommendations-sliders': recommendationsSliders,
  'product.color-options': colorOptions,
});
